/**
 * Каталог кабеля: типовые марки для квартирной проводки и их цвета на плане.
 */
import { LayerKind } from "@/shared/plan/layerKind";
import type { CatalogSection } from "../../types";
import { CablePurpose, type CableCatalogItem } from "./types";

export const cableSection: CatalogSection<CableCatalogItem> = {
	kind: LayerKind.Wiring,
	label: "Кабель",
	canChangeDimensions: false,
	subGroups: ["Силовой", "Слаботочный"],
	items: [
		{
			id: "cable-vvg-3x2.5",
			subGroup: "Силовой",
			name: "ВВГнг-LS 3×2,5",
			description: "Розеточные группы: медь, три жилы по 2,5 мм².",
			color: "#0f766e",
			purpose: CablePurpose.Power,
			cores: 3,
			crossSection: 2.5,
		},
		{
			id: "cable-vvg-3x1.5",
			subGroup: "Силовой",
			name: "ВВГнг-LS 3×1,5",
			description: "Группы освещения: медь, три жилы по 1,5 мм².",
			color: "#c2410c",
			purpose: CablePurpose.Lighting,
			cores: 3,
			crossSection: 1.5,
		},
		{
			id: "cable-vvg-5x2.5",
			subGroup: "Силовой",
			name: "ВВГнг-LS 5×2,5",
			description:
				"Пример пятижильного кабеля для трёхфазной линии. Сечение выбирается по расчёту.",
			color: "#be123c",
			purpose: CablePurpose.ThreePhase,
			cores: 5,
			crossSection: 2.5,
		},
		{
			id: "cable-utp",
			subGroup: "Слаботочный",
			name: "UTP cat.5e",
			description: "Локальная сеть и интернет: витая пара, четыре пары.",
			color: "#7c3aed",
			purpose: CablePurpose.LowVoltage,
			cores: 8,
			crossSection: 0.2,
		},
		{
			id: "cable-coaxial-rg6",
			subGroup: "Слаботочный",
			name: "Коаксиальный RG-6",
			description: "Коаксиальный кабель для телевизионного сигнала.",
			color: "#a16207",
			purpose: CablePurpose.Tv,
			cores: 1,
		},
	],
};
